import React from "react"
import DropDownSelect from "aldoo-ra/DropdownSelect"

/**
 * One value out of a list, on the aldoo-ra DropDownSelect: `options` are
 * [value, label] pairs or { value, label, hint } objects, and `onChange` gets
 * the value. A hint (a metric's group, say) is shown under the label in the
 * menu. Something is always picked: picking the chosen one again keeps it.
 */
export default function Select({ value, options, onChange, className = "", searchEnabled = false, testId }) {
  const items = options.map((o) => (Array.isArray(o) ? { value: o[0], label: o[1] } : o))
  const selected = items.find((o) => String(o.value) === String(value))

  return (
    <div className={`min-w-0 ${className}`} data-testid={testId}>
      <DropDownSelect
        variant="admin"
        options={items}
        value={selected ? [selected] : []}
        onChange={(sel) => {
          const picked = Array.isArray(sel) ? sel[0] : sel
          if (picked == null) return
          onChange(picked.value)
        }}
        nameField="label"
        searchEnabled={searchEnabled}
        enableResetButton={false}
        showCheckbox={false}
        showSelectionTick
        allowEmptySelection={false}
        onItemRender={(o) => (
          <span className="flex flex-col py-0.5">
            <span className="text-sm text-admin_text">{o.label}</span>
            {o.hint && o.hint !== o.label && <span className="text-[11px] text-admin_text_secondary">{o.hint}</span>}
          </span>
        )}
        onValueItemRender={(o) => {
          const item = Array.isArray(o) ? o[0] : o
          return <span className="truncate text-sm">{item?.label ?? selected?.label ?? ""}</span>
        }}
      />
    </div>
  )
}
